import { render, staticRenderFns } from "./DocumentTargetList.vue?vue&type=template&id=494f528f&scoped=true"
import script from "./DocumentTargetList.vue?vue&type=script&lang=js"
export * from "./DocumentTargetList.vue?vue&type=script&lang=js"
import style0 from "./DocumentTargetList.vue?vue&type=style&index=0&id=494f528f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f528f",
  null
  
)

export default component.exports